import { zergApi } from "@/service/zerg";

class VehiclesService {

    async getSettingVehiclesForSelect() {
        try {
            const data = await zergApi.post("setting/vehicles/get-setting-vehicles-for-select");
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getSettingVehiclesFilteredForSelect(params) {
        try {
            const data = await zergApi.post("setting/vehicles/get-setting-vehicles-filtered-for-select", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getMeasureTypesFiltered(params) {
        try {
            const data = await zergApi.post("setting/vehicles/get-mearure-types-filtered", params);
            return data
        } catch (error) {
            throw error;
        }
    }

    async getMeasureTypesFilteredForEdit(params) {
        try {
            const data = await zergApi.post("setting/vehicles/get-mearure-types-filtered-for-edit", params);
            return data
        } catch (error) {
            throw error;
        }
    }

    async getVehiclesForSelect(params) {
        try {
            const data = await zergApi.post("setting/vehicles/get-vehicles-for-select", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getVehicleInfoForTravel(params) {
        try {
            const data = await zergApi.get("setting/vehicles/get-vehicle-info-for-travel", { params });
            return data;
        } catch (error) {
            throw error;
        }
    }
}

export default new VehiclesService();